import axios from 'axios';
import { toast } from 'react-hot-toast';


const API_URL = process.env.REACT_APP_API_HOST

export const getTypeOfProperty = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'TYPE_OF_PROPERTY_REQUEST' });
            const { data } = await axios.get(`${API_URL}/type-of-property`);
            dispatch({ type: 'TYPE_OF_PROPERTY_SUCCESS', typeOfProperty: data });
        }
        catch (error) {
            dispatch({ type: 'TYPE_OF_PROPERTY_FAILURE', error: error.message });
        }
    }
}

export const createTypeOfProperty = (typeOfProperty) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'TYPE_OF_PROPERTY_CREATE_REQUEST' });
            const { data } = await axios.post(`${API_URL}/type-of-property`, typeOfProperty, {
                headers: {
                    Authorization: localStorage.getItem('xat')
                }
            });
            dispatch({ type: 'TYPE_OF_PROPERTY_CREATE_SUCCESS', typeOfProperty: data });
            toast.success('Type of property created successfully!');
        } catch (error) {
            toast.error(error.response.data.message);
            dispatch({ type: 'TYPE_OF_PROPERTY_CREATE_FAILURE', error: error.message });
        }
    }
}

export const updateTypeOfProperty = (id, typeOfProperty) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'TYPE_OF_PROPERTY_UPDATE_REQUEST' });
            const { data } = await axios.put(`${API_URL}/type-of-property/${id}`, typeOfProperty, {
                headers: {
                    Authorization: localStorage.getItem('xat')
                }
            });
            dispatch({ type: 'TYPE_OF_PROPERTY_UPDATE_SUCCESS', typeOfProperty: data });
            toast.success('Type of property updated successfully!');
        } catch (error) {
            toast.error(error.response.data.message);
            dispatch({ type: 'TYPE_OF_PROPERTY_UPDATE_FAILURE', error: error.message });
        }
    }
}

export const deleteTypeOfProperty = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'TYPE_OF_PROPERTY_DELETE_REQUEST' });
            const config = {
                headers: {
                    Authorization: localStorage.getItem('xat')
                }
            }
            const { data } = await axios.delete(`${API_URL}/type-of-property/${id}`, config);
            dispatch({ type: 'TYPE_OF_PROPERTY_DELETE_SUCCESS', typeOfProperty: data });
            toast.success('Type of property deleted successfully!');
        } catch (error) {
            dispatch({ type: 'TYPE_OF_PROPERTY_DELETE_FAILURE', error: error.message });
        }
    }
}

export const setRedirect = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: 'SET_REDIRECT' });
        } catch (error) {
            dispatch({ type: 'SET_REDIRECT', error: error.message });
        }
    }
} 